import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
import { ShieldCheckIcon, BrainCircuitIcon, BanknoteIcon, UsersIcon } from 'lucide-react';
export function CapabilitiesSection() {
  const capabilities = [{
    title: 'Post-Quantum Secure Integration Layer',
    description: 'Simplify and harden connections between core systems and third parties with cryptography designed for the post-quantum era.',
    icon: ShieldCheckIcon
  }, {
    title: 'AI-Driven Customer Intelligence',
    description: 'Trust scoring, behavioral analytics, and explainable AI to match customers with the right products at the right time.',
    icon: BrainCircuitIcon
  }, {
    title: 'Bank-Owned Micro-Lending',
    description: 'Launch and manage micro-lending programs that keep revenue within your institution, powered by proprietary trust scoring.',
    icon: BanknoteIcon
  }, {
    title: 'Embedded P2P Lending',
    description: 'Regulated peer-to-peer lending functionality embedded directly into your digital channels, under your compliance framework.',
    icon: UsersIcon
  }];
  return <section id="capabilities" className="py-24 bg-slate relative overflow-hidden" data-id="element-43">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-teal/5 rounded-full blur-[120px] pointer-events-none" data-id="element-44"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-45">
        <FadeIn className="text-center mb-20 max-w-3xl mx-auto" data-id="element-46">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-47">
            Four Integrated Capabilities.
            <br data-id="element-48" />
            <span className="text-teal" data-id="element-49">One Modular Platform.</span>
          </h2>
          <p className="text-xl text-gray-400" data-id="element-50">
            Each module works independently or together — deployed under your
            brand, on your terms.
          </p>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-51">
          {capabilities.map((cap, index) => {
          const Icon = cap.icon;
          return <StaggerItem key={index} data-id="element-52">
                <div className="bg-navy border border-white/10 rounded-2xl p-10 h-full relative group hover:-translate-y-1 hover:shadow-[0_10px_40px_-10px_rgba(0,212,170,0.15)] hover:border-teal/30 transition-all duration-300" data-id="element-53">
                  {/* Subtle teal accent line */}
                  <div className="absolute top-0 left-8 w-16 h-1 bg-teal rounded-b-md opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-54"></div>

                  <div className="mb-6 inline-flex p-4 rounded-xl bg-slate border border-white/5 text-teal group-hover:scale-110 transition-transform duration-300" data-id="element-55">
                    <Icon className="w-8 h-8" strokeWidth={1.5} data-id="element-56" />
                  </div>

                  <h3 className="text-2xl font-semibold text-white mb-4" data-id="element-57">
                    {cap.title}
                  </h3>
                  <p className="text-gray-400 text-lg leading-relaxed" data-id="element-58">
                    {cap.description}
                  </p>
                </div>
              </StaggerItem>;
        })}
        </StaggerContainer>
      </div>
    </section>;
}